// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ii-0";
export var animationContainer = "_ii-1";
export var modalContent = "_ii-2";
export var orderName = "_ii-3";
export var refundOption = "_ii-4";
export var refundOptionsContainer = "_ii-5";